import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import CommissionPointsAndPrice from '../../../CommissionPointsAndPrice';
import { formatDollars } from '../../../utils/formatting';
import { ActionBarProps as Props } from '../../types';

import s from './CommissionActionBar.scss';

const CommissionActionBar: React.FC<React.PropsWithChildren<Props>> = ({
  isOwner,
  deviation: { commission },
  deviation,
  className,
}) => {
  const {
    hasMoreActions,
    isCommentable,
    isEditable,
    isDeletable,
    isAuthorCommissionable,
  } = useDeviationAttributes(deviation, isOwner);

  if (!commission) {
    return null;
  }

  return (
    <ActionBarStrip className={className}>
      <CentralColumn className={s['bar-elements-wrapper']}>
        <div className={s['left-side']}>
          {isCommentable && (
            <span className={s['icon']}>
              <CommentButton deviation={deviation} isOwner={isOwner} />
            </span>
          )}
        </div>
        <div className={s['right-side']}>
          {(isOwner || commission.isActive) && isAuthorCommissionable && (
            <span className={s['icon']}>
              <div className={s['price']}>
                <CommissionPointsAndPrice
                  points={commission.pointsCost}
                  price={formatDollars(commission.dollarsCost)}
                />
              </div>
            </span>
          )}
          {!isOwner && isAuthorCommissionable && (
            <span className={s['icon']}>
              <OrderCommissionButton deviation={deviation} />
            </span>
          )}
          {isEditable && (
            <span className={s['icon']}>
              <CommissionStatusButton deviation={deviation} />
            </span>
          )}
          {isDeletable && (
            <span className={s['icon']}>
              <DeleteButton deviation={deviation} />
            </span>
          )}
          {isEditable && (
            <span className={s['icon']}>
              <EditButton deviation={deviation} />
            </span>
          )}
          {hasMoreActions && (
            <span className={s['icon']}>
              <MoreButton deviation={deviation} />
            </span>
          )}
        </div>
      </CentralColumn>
    </ActionBarStrip>
  );
};
CommissionActionBar.displayName = 'CommissionActionBar';

export default CommissionActionBar;
